import { action, createRequestTypes } from "../../actions";

export const LOGIN = createRequestTypes("LOGIN");
export const VERIFY_VERSION = createRequestTypes("VERIFY_VERSION");
export const LOGIN_VALUE = createRequestTypes("LOGIN_VALUE");
export const PROVIDER_LOGIN = createRequestTypes("PROVIDER_LOGIN");
export const SOCIAL_LOGIN = createRequestTypes("SOCIAL_LOGIN");
export const CODE_LOGIN = createRequestTypes("CODE_LOGIN");
export const CREATE_OTP = createRequestTypes("CREATE_OTP");
export const LOGIN_OTP = createRequestTypes("LOGIN_OTP");
export const LOGIN_STUDENT_OTP = createRequestTypes("LOGIN_STUDENT_OTP");
export const USER = createRequestTypes("USER");
export const REGISTER = createRequestTypes("REGISTER");
export const LOGOUT = createRequestTypes("LOGOUT");
export const PASSWORD = createRequestTypes("PASSWORD");
export const PASSWORD_RESET = createRequestTypes("PASSWORD_RESET");

export const login = {
  request: (username, password) => action(LOGIN.REQUEST, { username, password }),
  success: (response) => action(LOGIN.SUCCESS, response),
  failure: error => action(LOGIN.FAILURE, error),
};

export const verifyVersion = {
  request: (version) => action(VERIFY_VERSION.REQUEST, { ui_version: version }),
  success: (response) => action(VERIFY_VERSION.SUCCESS, response),
  failure: error => action(VERIFY_VERSION.FAILURE, error),
};

export const loginValue = {
  request: (code, fullName) => action(LOGIN_VALUE.REQUEST, { code, fullName }),
  success: (response) => action(LOGIN_VALUE.SUCCESS, response),
  failure: error => action(LOGIN_VALUE.FAILURE, error),
};

export const socialLogin = {
  request: (provider) => action(SOCIAL_LOGIN.REQUEST, { provider }),
  success: (response) => action(SOCIAL_LOGIN.SUCCESS, response),
  failure: error => action(SOCIAL_LOGIN.FAILURE, error),
};

export const providerLogin = {
  request: (provider, state, code) => action(PROVIDER_LOGIN.REQUEST, { provider, state, code }),
  success: (response) => action(PROVIDER_LOGIN.SUCCESS, response),
  failure: error => action(PROVIDER_LOGIN.FAILURE, error),
};

export const codeLogin = {
  request: (code, email) => action(CODE_LOGIN.REQUEST, { code, email }),
  success: (response) => action(CODE_LOGIN.SUCCESS, response),
  failure: error => action(CODE_LOGIN.FAILURE, error),
};

export const otpLogin = {
  request: (code) => action(LOGIN_OTP.REQUEST, { code }),
  success: () => action(LOGIN_OTP.SUCCESS, { }),
  failure: error => action(LOGIN_OTP.FAILURE, error),
};

export const studentLoginOTP = {
  request: (code) => action(LOGIN_STUDENT_OTP.REQUEST, { code }),
  success: () => action(LOGIN_STUDENT_OTP.SUCCESS, { }),
  failure: error => action(LOGIN_STUDENT_OTP.FAILURE, error),
};

export const loadUser = {
  request: () => action(USER.REQUEST, {}),
  success: user => action(USER.SUCCESS, { user }),
  failure: error => action(USER.FAILURE, error),
};

export const register = {
  request: (email, password) =>
    action(REGISTER.REQUEST, {
      email,
      password,
    }),
  success: res => action(REGISTER.SUCCESS, { user: res.data }),
  failure: error => action(REGISTER.FAILURE, error),
};

export const logout = {
  request: () => action(LOGOUT.REQUEST, {}),
};

export const password = {
  request: (email) =>
    action(PASSWORD.REQUEST, {
      email,
    }),
  success: () => action(PASSWORD.SUCCESS, {}),
  failure: error => action(PASSWORD.FAILURE, error),
};

export const passwordReset = {
  request: (new_pwd, re_new_pwd, uuid, token) =>
    action(PASSWORD_RESET.REQUEST, {
      new_pwd,
      re_new_pwd,
      uuid,
      token,
    }),
  success: () => action(PASSWORD_RESET.SUCCESS, {}),
  failure: error => action(PASSWORD_RESET.FAILURE, error),
};
